import {
  OreButton,
  OreHeading,
  OreStack,
  OreText,
  SvgRepeat,
} from '@edenredespana/oreneta'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { T } from 'vitest/dist/chunks/reporters.d.BFLkQcL6.js'

import { RegisterOrigin } from '@/Account/domain'
import ErrorLogo from '@/Account/ui/assets/Warning.svg'
import { SignUpTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { openNavigationRoutes } from '@/Shared/ui/routers'

import { LoginTranslation } from '../accountTranslation'

interface TokenErrorPageProps {
  registerOrigin?: number
  isNursery?: boolean
  isServerError?: boolean
}

export const TokenErrorPage = ({
  registerOrigin,
  isNursery,
  isServerError,
}: TokenErrorPageProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div style={{ margin: '3rem 18% 0 18%' }}>
      <OreStack
        direction="column"
        space="large"
        placeContent="space-between"
        placeItems="center"
      >
        <div>
          <figure>
            <img src={ErrorLogo} alt="" />
          </figure>
        </div>
        <OreStack direction="column" space="medium">
          <header className="width-max">
            <OreHeading as="h1" size="title-sm" align="center">
              {t(LoginTranslation.register.errorPage.title)}
            </OreHeading>
          </header>
          <div>
            {isServerError ? (
              <OreStack direction="column" space="medium">
                <OreText align="center" size="text-md">
                  {t(LoginTranslation.register.errorPage.ServerError)}
                </OreText>
                <OreText align="center" size="text-md">
                  <Trans
                    t={t}
                    components={[
                      <a href={`mailto:${import.meta.env.VITE_CONTACT_EMAIL}`} />,
                    ]}
                  >
                    {t(LoginTranslation.register.errorPage.ServerError2, {
                      CONTACT_PHONE: t(SignUpTranslation.otp.tel),
                      CONTACT_EMAIL: import.meta.env.VITE_CONTACT_EMAIL,
                    })}
                  </Trans>
                </OreText>
              </OreStack>
            ) : isNursery ? (
              <Trans t={t}>
                <OreText align="center">{t(LoginTranslation.guarderia.token)}</OreText>
              </Trans>
            ) : registerOrigin === RegisterOrigin.SelfAccountCreation ? (
              <Trans t={t}>
                <OreText align="center">
                  {t(LoginTranslation.register.errorPage.SelfAccountCreationText)}
                </OreText>
              </Trans>
            ) : registerOrigin === RegisterOrigin.ManagerWithRoleAccountCreation ? (
              <Trans t={t}>
                <OreText align="center">
                  {t(LoginTranslation.register.errorPage.ManagerWithRoleAccountCreation)}
                </OreText>
              </Trans>
            ) : (
              <OreStack space="small">
                <OreText align="center">
                  {t(LoginTranslation.register.errorPage.default_1)}
                </OreText>
                <OreText align="center">
                  <Trans
                    t={t}
                    components={[
                      <a href={`mailto:${import.meta.env.VITE_CONTACT_EMAIL}`} />,
                    ]}
                  >
                    {t(LoginTranslation.register.errorPage.default_2, {
                      CONTACT_PHONE: import.meta.env.VITE_WEB_CONTACT_PHONE,
                      CONTACT_EMAIL: import.meta.env.VITE_CONTACT_EMAIL,
                    })}
                  </Trans>
                </OreText>
              </OreStack>
            )}
          </div>
        </OreStack>
        {registerOrigin === RegisterOrigin.SelfAccountCreation &&
          !isNursery &&
          !isServerError && (
            <OreStack
              direction="column"
              space="small"
              placeContent="space-between"
              placeItems="center"
            >
              <OreButton
                as="button"
                category="primary"
                onClick={() => navigate(openNavigationRoutes.login)}
                size="large"
                icon={<SvgRepeat />}
                iconAlign="right"
              >
                {t(LoginTranslation.register.errorPage.button)}
              </OreButton>
            </OreStack>
          )}
      </OreStack>
    </div>
  )
}
